import React, {useEffect, useReducer} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';

const initialState = {
  loading: true,
  numberFilterRowCount: 1,
  numberFilterData: {
    fr1: {
      condition: 'eq',
      value: '',
    },
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'update_loading_status':
      return {
        ...state,
        loading: action.payload,
      };
    case 'update_number_filter_data':
      return {
        ...state,
        numberFilterData: action.payload.numberFilterData,
        numberFilterRowCount: action.payload.numberFilterRowCount,
      };
    case 'update_number_filter_data_loading_status':
      return {
        ...state,
        numberFilterData: action.payload.numberFilterData,
        numberFilterRowCount: action.payload.numberFilterRowCount,
        loading: false,
      };
    default:
      return state;
  }
};

const DTHNumberFilterLayout = props => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const {loading, numberFilterRowCount, numberFilterData} = state;

  const {
    data: {namespace},
    filterData,
    onFilterChange,
  } = props;

  useEffect(() => {
    setTimeout(() => {
      if (filterData && filterData.hasOwnProperty(namespace)) {
        const count = Math.round(Object.keys(filterData[namespace]).length / 2);
        dispatch({
          type: 'update_number_filter_data_loading_status',
          payload: {
            numberFilterData: filterData[namespace],
            numberFilterRowCount: count,
          },
        });
      } else dispatch({
        type: 'update_number_filter_data_loading_status',
        payload: {
          numberFilterData: {
            fr1: {
              condition: 'eq',
              value: '',
            },
          },
          numberFilterRowCount: 1,
        },
      });
    }, 200);
  }, [filterData, namespace]);

  const addFieldRow = () => {
    let tempBaseFilterData = {...numberFilterData};
    const incBaseFilterRowCount = numberFilterRowCount + 1;

    tempBaseFilterData['lfr' + incBaseFilterRowCount] = 'and';
    tempBaseFilterData['fr' + incBaseFilterRowCount] = {
      condition: 'eq',
      value: '',
    };

    dispatch({
      type: 'update_number_filter_data',
      payload: {
        numberFilterData: tempBaseFilterData,
        numberFilterRowCount: incBaseFilterRowCount,
      },
    });
  };

  const removeFieldRow = () => {
    if (numberFilterRowCount > 1) {
      let tempBaseFilterData = {...numberFilterData};

      if (tempBaseFilterData.hasOwnProperty(
          'lfr' + numberFilterRowCount)) delete tempBaseFilterData['lfr' +
      numberFilterRowCount];
      if (tempBaseFilterData.hasOwnProperty(
          'fr' + numberFilterRowCount)) delete tempBaseFilterData['fr' +
      numberFilterRowCount];

      dispatch({
        type: 'update_number_filter_data',
        payload: {
          numberFilterData: tempBaseFilterData,
          numberFilterRowCount: numberFilterRowCount - 1,
        },
      });
    }
  };

  const handleOperatorChange = event => {
    const {name, value} = event.target;
    let tempBaseFilterData = {...numberFilterData};
    tempBaseFilterData[name] = value;
    dispatch({
      type: 'update_number_filter_data',
      payload: {
        numberFilterData: tempBaseFilterData,
        numberFilterRowCount,
      },
    });
  };

  const handleFilterRowDataChange = event => {
    const {name = '', value = ''} = event.target;
    const tempBaseFilterData = {...numberFilterData};
    const splitName = name.split('-');
    tempBaseFilterData[splitName[0]][splitName[1]] = value;
    dispatch({
      type: 'update_number_filter_data',
      payload: {
        numberFilterData: tempBaseFilterData,
        numberFilterRowCount,
      },
    });
  };

  const sendFilterDataToParent = () => {
    let tempFilterData = {...filterData};
    tempFilterData[namespace] = numberFilterData;
    onFilterChange(tempFilterData);
  };

  const resetFilter = () => {
    let tempFilterData = {...filterData};
    if (tempFilterData.hasOwnProperty(namespace)) {
      delete tempFilterData[namespace];
      onFilterChange(tempFilterData);
    }
    dispatch({
      type: 'update_number_filter_data',
      payload: {
        numberFilterData: {
          fr1: {
            condition: 'eq',
            value: '',
          },
        },
        numberFilterRowCount: 1,
      },
    });
  };

  const buildFieldRows = () => {
    let fieldRows = [], i;
    for (i = 1; i <= numberFilterRowCount; i++) {
      if (numberFilterData.hasOwnProperty('lfr' + i)) {
        const currOperatorValue = numberFilterData['lfr' + i];
        fieldRows.push(
            <select
                name={`lfr${i}`}
                key={'lfr' + i}
                className="um-select mt-5 mb-15"
                style={{width: 100}}
                value={currOperatorValue}
                onChange={handleOperatorChange}
            >
              <option value="and">AND</option>
              <option value="or">OR</option>
              <option value="nor">NOR</option>
            </select>,
        );
      }

      if (numberFilterData.hasOwnProperty('fr' + i)) {
        const {condition, value} = numberFilterData['fr' + i];
        const isValueDisabled = ['exist', 'nil', 'blank'].includes(condition);

        fieldRows.push(
            <div className="field-rows-wrapper" key={'fr' + i}>
              <select
                  name={`fr${i}-condition`}
                  className="um-select"
                  value={condition}
                  onChange={handleFilterRowDataChange}
              >
                <option value="eq">Equals to</option>
                <option value="ne">Not equals to</option>
                <option value="gt">Greater than</option>
                <option value="gte">Greater than or equal to</option>
                <option value="lt">Less than</option>
                <option value="lte">Less than or equal to</option>
                <option value="exist">Exist</option>
                <option value="nil">Nil</option>
              </select>
              <input
                  type="number"
                  name={`fr${i}-value`}
                  className="um-input"
                  value={value}
                  disabled={isValueDisabled}
                  onChange={handleFilterRowDataChange}
              />
            </div>,
        );
      }
    }
    return fieldRows;
  };

  return (
      <>
        <div className="dropdown-inner-section">
          {
            loading ? (
                <h3 className="text-center mt-20 mb-20">
                  <FontAwesomeIcon
                      className="loading-icon mr-5"
                      icon={faSpinner}
                      spin
                  /> Loading..</h3>
            ) : (
                <>
                  {buildFieldRows()}
                  <div>
                    <button
                        className="um-button um-button--primary mr-5 mt-0 mb-0"
                        onClick={addFieldRow}
                    >+
                    </button>
                    <button
                        className="um-button um-button--danger mt-0 mb-0"
                        onClick={removeFieldRow}
                    >-
                    </button>
                  </div>
                </>
            )
          }
        </div>
        <div className="dropdown-inner-action-section">
          <button
              className="filter"
              type="button"
              onClick={sendFilterDataToParent}
          >Filter
          </button>
          <button
              className="clear um-button um-button--reset"
              type="button"
              onClick={resetFilter}
          >Clear
          </button>
        </div>
      </>
  );
};

export default DTHNumberFilterLayout;
